<template>
<div class="landing">
  <div class="member_wrap">
    <h1 :class="computedTitle[0].booleans ? 'title' : ''">
      <img src="/images/logo/logo-rebless.svg" alt="logo">
      <span v-if="computedTitle[0].booleans">{{ this.$t(`${computedTitle[0].title}`) }}</span>
    </h1>
    <router-view></router-view>
    <CheckEmailAuthModal/>
  </div>
  <CountryNotice style="position: absolute; bottom: 0; width: 100%;" />
</div>
</template>
<script>
import CheckEmailAuthModal from '@/components/modal/checkEmailAuth'

export default {
  name: 'Landing',
  components: {
    CheckEmailAuthModal,
    CountryNotice: () => import('@/components/common/CountryNotice'),
  },
  data() {
    return {
      path: 'login',
      title: [
        {
          name: 'login',
          booleans: false,
          title: ''
        },
        {
          name: 'findPassword',
          booleans: false,
          title: ''
        },
        {
          name: 'signUp',
          booleans: true,
          title: 'account.provider_inquiry_form'
        }
      ]
    }
  },
  watch: {
    $route: {
      deep: true,
      handler(newVal) {
        this.path = newVal.path.slice(1).split('/')[0];
      }
    }
  },
  computed: {
    computedTitle() {
      return this.title.filter((item) => {
        return item.name === this.path

      })
    }
  },
  created() {
    this.path = this.$route.path.slice(1).split('/')[0];
  }
}
</script>
<style lang="scss">
.landing .member_wrap {
  margin: 0 30px;

  @media screen and (min-width: 320px) and (max-width: 600px) {
    overflow: auto;
    height: var(--app-height);
  }
}
</style>